/* eslint-disable @typescript-eslint/no-explicit-any */ import { eventHelper } from "./EventHelper";
function on(eventType, selector) {
    return function(target, propertyKey, descriptor) {
        eventHelper.on(target, eventType, descriptor.value, selector);
    };
}
export { on };
